import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

import { ConstantsModule } from './../constants/constants.module';
import { DialogPage } from './../root_classes/dialog-page';

@Component({
	selector: 'app-user-add-minicompany',
	templateUrl: './user-add-minicompany.component.html',
	styleUrls: ['./user-add-minicompany.component.scss']
})
export class UserAddMinicompanyComponent extends DialogPage implements OnInit {

	// Form data.
	userAddMiniCompanyForm = new FormGroup({
		nameControl: new FormControl('', [Validators.required]),
	});

	// Extra data.
	public buttonText: string;
	public enableAction: boolean;

	constructor(constantsModule:ConstantsModule, cookieService:CookieService, httpClient:HttpClient, router:Router, modalService:NgbModal, modalInstance:NgbActiveModal) {
		super(constantsModule, cookieService, httpClient, router, modalService, modalInstance);

		// Save button infos.
		this.buttonText = "Ajouter";
		this.enableAction = true;
	}

	ngOnInit(): void {
	}

	public doAddCompany(): void {
		this.alertLine.resetAllMessages();

		var companyData = {
			"name":this.userAddMiniCompanyForm.controls["nameControl"].value.toUpperCase()
		};
		this.put("/api/company-exists", companyData,
			(response:any) => {
				if (response.DATA == "ERR") {
					switch (response.VALUE) {
						case "DATABASE":
							this.alertLine.alertDangerMessage = "Impossible de se connecter à la base de données. Contactez votre administrateur.";
							break;
						case "ENTITY ALREADY EXISTS":
							this.alertLine.alertDangerMessage = "Cette société existe déjà.";
							break;
					}
					return;
				} else {
					this.modalInstance.dismiss(companyData["name"]);
				}
			},
			(reason:any) => {
				this.modalInstance.close(reason);
			}
		);
	}
}
